import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Button, Modal, Spin, message } from "antd";
import { LoadingOutlined, MoreOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import liracrypt from "../../../Liracrypt/liracrypt";
import ApiErrorComp from "../../../ApiErrorComp/ApiErrorComp";
import { createRoute } from "../../../../utils/CustomFunc";
import noImg from '../../../../assets/static/noImg.jpeg';
import { useSelector } from "react-redux";
import ZenModal from "../../../ZenModal";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
am4core.useTheme(am4themes_animated);

const ZenStackedNePo = (props) => {
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  const [zenModal, setZenModal] = useState();
  const urlCode = useSelector(state => state.urlCode);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chart = useRef(null);
  const [chartData, setChartData] = useState();
  const [chartConfig, setChartConfig] = useState();
  const [modal, setModal] = useState({
    type: "route",
    data: undefined,
    show: false,
    loading: false
  });

  const toggleModal = ({ show = false, data = undefined, type = '', loading = false }) => {
    setModal({ show, data, type, loading });
  }
  // Use only absolute numbers
  // chart.numberFormatter.numberFormat = "#.#s";

  const createChart = (args, chart) => {
    if (args.data) {
      chart.data = args.data;
      if (args.config.legend.enable === true) {
        chart.legend = new am4charts.Legend();
        chart.legend.position = args.config.legend.position;
        chart.legend.labels.template.fill = am4core.color(args.config.legend.color);
      }

      //title
      if (args.config.title.enable === true) {
        var title = chart.titles.create();
        title.text = args.config.title.val;
        title.fontSize = args.config.title.fontSize;
        title.margin = args.config.title.margin;
        title.padding = args.config.title.padding;
        title.fontWeight = args.config.title.fontWeight;
        title.fill = args.config.title.color;
      }

      // Create axes
      var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.extraMin = 0.1;
      valueAxis.extraMax = 0.1;
      valueAxis.renderer.minGridDistance = 40;
      valueAxis.renderer.ticks.template.length = 5;
      valueAxis.renderer.labels.template.fontSize = args.config.valueLabel.fontSize;
      valueAxis.renderer.labels.template.fill = args.config.valueLabel.color;
      // if (args.config.chartDiv.grid.gridHorizontal === true) {
      //   valueAxis.renderer.line.strokeOpacity = 0.2;
      //   valueAxis.renderer.line.strokeWidth = 1;
      //   valueAxis.renderer.line.stroke = am4core.color(
      //     args.config.chartDiv.grid.gridColor
      //   );
      //   valueAxis.renderer.grid.template.stroke = args.config.chartDiv.gridColor;
      // } else {
      //   valueAxis.renderer.grid.template.strokeWidth = 0;
      //   }

      if (args.config.valueAxis.enable === false) {
        valueAxis.renderer.labels.template.disabled = true;
      }

      valueAxis.renderer.labels.template.adapter.add("text", function (text) {
        return text == "Male" || text == "Female" ? text : text + "%";
      })

      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = args.config.categoryAxis.categoryKey;
      categoryAxis.renderer.minGridDistance = args.config.categoryAxis.minGridDistance;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.inversed = true;
      categoryAxis.renderer.grid.template.stroke = args.config.chartDiv.gridColor;
      categoryAxis.renderer.grid.template.strokeWidth = 0;
      categoryAxis.renderer.labels.template.fontSize =
        args.config.categoryAxis.fontSize;
      categoryAxis.renderer.labels.template.fill = args.config.categoryAxis.color;
      categoryAxis.renderer.line.strokeOpacity = 0.2;
      categoryAxis.renderer.line.strokeWidth = 1;
      categoryAxis.renderer.labels.template.dx = args.config.categoryAxis.dx;
      categoryAxis.renderer.labels.template.dy = args.config.categoryAxis.dy;
      if (args.config.categoryAxis.wrap === true) {
        categoryAxis.renderer.labels.template.wrap = true;
        categoryAxis.renderer.labels.template.maxWidth = args.config.categoryAxis.wrapMaxWidth;
      }



      // /* Create Male series */


      var columnSeriesMale = chart.series.push(new am4charts.ColumnSeries());
      columnSeriesMale.dataFields.valueX = args.config.columnSeriesMale.columnSeriesvalueY;
      columnSeriesMale.dataFields.categoryY = args.config.categoryAxis.categoryKey;
      columnSeriesMale.clustered = false;
      columnSeriesMale.name = args.config.columnSeriesMale.name;
      columnSeriesMale.columns.template.width = am4core.percent(
        args.config.columnSeriesMale.columnWidth
      );
      columnSeriesMale.columns.template.clickable = true;
      columnSeriesMale.columns.template.tooltipText =
        args.config.columnSeriesMale.tooltipText;
      columnSeriesMale.columns.template.fillOpacity = 0.8;
      columnSeriesMale.columns.template.strokeOpacity = 0;
      columnSeriesMale.dataFields._id = '_id';

      columnSeriesMale.columns.template.events.on(
        "hit",
        function (ev) {
          if (args?.config?.zenPop?.typ === 'comboRefresh') {
            if (props.onChange) {
              let urlData = args?.config?.zenPop?.params;
              let changeKey = args?.config?.zenPop?.comboRefreshId
              urlData[changeKey] = ev.target.dataItem._id;
              props.onChange({
                apiUrl: args?.config?.zenPop?.api,
                urlData,
                changeKey
              });
            }
          } else {
            onColumnClick(ev.target.dataItem.dataContext);
          }
        },
        this
      );
      if (args.config.columnSeriesMale.shadow.enable === true) {
        var shadow = columnSeriesMale.filters.push(new am4core.DropShadowFilter());
        shadow.dx = args.config.columnSeriesMale.shadow.dx;
        shadow.dy = args.config.columnSeriesMale.shadow.dy;
        shadow.blur = args.config.columnSeriesMale.shadow.blur;
      }

      if (args.config.valueLabel.enable === true) {
        var valueLabel = columnSeriesMale.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.fill = am4core.color(args.config.valueLabel.color);
        valueLabel.label.text = args.config.valueLabel.val;
        valueLabel.label.fontSize = args.config.valueLabel.fontSize;
        valueLabel.label.verticalCenter = args.config.valueLabel.verticalCenter;
        valueLabel.label.horizontalCenter = args.config.valueLabel.horizontalCenter;
        valueLabel.label.dx = args.config.valueLabel.dx;
        valueLabel.label.dy = args.config.valueLabel.dy;
      }

      var columnSeriesFemale = chart.series.push(new am4charts.ColumnSeries());
      columnSeriesFemale.dataFields.valueX = args.config.columnSeriesFemale.columnSeriesvalueY;
      columnSeriesFemale.dataFields.categoryY = args.config.categoryAxis.categoryKey;
      columnSeriesFemale.clustered = false;
      columnSeriesFemale.name = args.config.columnSeriesFemale.name;
      columnSeriesFemale.columns.template.width = am4core.percent(
        args.config.columnSeriesFemale.columnWidth
      );
      columnSeriesFemale.columns.template.clickable = true;
      columnSeriesFemale.columns.template.tooltipText =
        args.config.columnSeriesFemale.tooltipText;
      columnSeriesFemale.columns.template.fillOpacity = 0.8;
      columnSeriesFemale.columns.template.strokeOpacity = 0;
      columnSeriesFemale.dataFields._id = '_id';

      columnSeriesFemale.columns.template.events.on(
        "hit",
        function (ev) {
          if (args?.config?.zenPop?.typ === 'comboRefresh') {
            if (props.onChange) {
              let urlData = args?.config?.zenPop?.params;
              let changeKey = args?.config?.zenPop?.comboRefreshId
              urlData[changeKey] = ev.target.dataItem._id;
              props.onChange({
                apiUrl: args?.config?.zenPop?.api,
                urlData,
                changeKey
              });
            }
          } else {
            onColumnClick(ev.target.dataItem.dataContext);
          }
        },
        this
      );
      if (args.config.columnSeriesFemale.shadow.enable === true) {
        var shadow = columnSeriesFemale.filters.push(new am4core.DropShadowFilter());
        shadow.dx = args.config.columnSeriesFemale.shadow.dx;
        shadow.dy = args.config.columnSeriesFemale.shadow.dy;
        shadow.blur = args.config.columnSeriesFemale.shadow.blur;
      }

      if (args.config.valueLabel.enable === true) {
        var valueLabel = columnSeriesFemale.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.fill = am4core.color(args.config.valueLabel.color);
        valueLabel.label.text = args.config.valueLabel.val;
        valueLabel.label.fontSize = args.config.valueLabel.fontSize;
        valueLabel.label.verticalCenter = args.config.valueLabel.verticalCenter;
        valueLabel.label.horizontalCenter = args.config.valueLabel.horizontalCenter;
        valueLabel.label.dx = args.config.valueLabel.dx;
        valueLabel.label.dy = args.config.valueLabel.dy;
      }

      var maleRange = valueAxis.axisRanges.create();
      maleRange.value = -10;
      maleRange.endValue = 0;
      maleRange.label.text = "Male";
      maleRange.label.fill = chart.colors.list[0];
      maleRange.label.dy = 20;
      maleRange.label.fontWeight = '600';
      maleRange.grid.strokeOpacity = 1;
      maleRange.grid.stroke = columnSeriesMale.stroke;

      var femaleRange = valueAxis.axisRanges.create();
      femaleRange.value = 0;
      femaleRange.endValue = 10;
      femaleRange.label.text = "Female";
      femaleRange.label.fill = chart.colors.list[1];
      femaleRange.label.dy = 20;
      femaleRange.label.fontWeight = '600';
      femaleRange.grid.strokeOpacity = 1;
      femaleRange.grid.stroke = columnSeriesFemale.stroke;
    }
  }


  const getApiChartData = (args) => {
    let params = { ...args?.params };
    liracrypt
      .get(props.api, { ...props.urlData, ...params })
      .then((response) => {
        console.log(response.data.data[props.divId]);
        if (!response.data.data[props.divId]) {
          return console.log("No Data Found");
        };
        if (props.setChartId) {
          props.setChartId(response.data.data[props.divId].meta._id);
        }
        if (props.setChartDataSource) {
          props.setChartDataSource(response.data.data[props.divId].meta.autoMan);
        }
        setChartData(response.data.data[props.divId]);
        // setTimeout(() => {
        //   chart = am4core.create(props.divId, am4charts.XYChart)
        //   createChart({
        //     data: response.data.data[props.divId].data,
        //     config: response.data.data[props.divId].config
        //   },
        //     chart);
        // }, 500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.refreshChart) {
      getApiChartData();
    }
  }, [props.refreshChart])

  /* CHART CREATION */
  useEffect(() => {
    let chart = null;
    if (props.api) {
      setChartData(null);
      getApiChartData();
    } else if (props.data) {
      setChartData({ data: props.data, config: props.config });
      // setTimeout(() => {
      //   chart = am4core.create(props.divId, am4charts.XYChart)
      //   createChart({ data: props.data, config: props.config }, chart);
      // }, 500);
    }
  }, [props?.data]);

  useEffect(() => {
    var chart = null;
    if (chartData) {
      chart = am4core.create(props.divId, am4charts.XYChart);
      createChart({ data: chartData.data, config: chartData.config }, chart);
      return () => {
        chart.dispose();
      };
    }
  }, [chartData]);

  useEffect(() => {
    let interval;
    if (chartData?.config?.dataRefreshInterval) {
      interval = setInterval(() => {
        getApiChartData();
      }, chartData?.config?.dataRefreshInterval);
    };
    return () => clearInterval(interval);
  }, [chartData?.config?.dataRefreshInterval]);

  const zenPopupAction = (zenPopup, value, record) => {
    let urlData = { ...searchParams, ...props.urlData, ...zenPopup.params };
    if (zenPopup?.props) {
      urlData[zenPopup?.props] = value;
    }
    if (zenPopup?.multiProps) {
      zenPopup?.multiProps.forEach((prop) => {
        urlData[prop] = record[prop];
      });
    }
    if (zenPopup?.typ === 'smodal') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          id: value,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    };
    if (zenPopup?.typ === 'route') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          route: zenPopup?.route,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    }
    if (zenPopup?.api) {
      toggleModal({ show: true, loading: true, type: zenPopup?.typ });
      liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
        toggleModal({
          show: true,
          data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
          loading: false,
          type: zenPopup?.typ
        })
      });
      return;
    }
    return toggleModal({
      show: true,
      data: zenPopup?.data,
      loading: false,
      type: zenPopup?.typ
    })
  }

  const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
    if (popData.method === 'GET') {
      liracrypt.get(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'POST') {
      liracrypt.post(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          console.log(err);
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'PATCH') {
      liracrypt.patch(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
  }

  const onColumnClick = (record) => {
    if (chartData?.config?.zenPop) {
      let zenPopDataIndex = { ...chartData?.config?.zenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }

  const onMenuClick = (record = {}) => {
    if (chartData?.config?.menuZenPop) {
      let zenPopDataIndex = { ...chartData?.config?.menuZenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }

  return (
    <div>
      {chartData ? (
        <>
          {
            chartData?.config?.menuZenPop?.enable ?
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={() => onMenuClick()} type="link" icon={
                  <MoreOutlined />}>{''}</Button>
              </div> : <></>
          }
          <div id={props.divId} style={chartData.config.chartDiv.style}></div>
          <ZenModal
            modal={modal}
            toggleModal={toggleModal}
            smodalCallback={props.api ? getApiChartData : props.smodalCallback}
            refreshData={props.api ? (params) => getApiChartData({ params }) : (params) => props.refreshData({ ...params })}
            zenModal={zenModal}
          />
        </>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default ZenStackedNePo;
